import {SOURCE_OPTIONS} from "./SourceOptions";

export const IMPORT_CONFIGURATION_COLUMNS = [
    {
        Header: "#",
        accessor: "id",
        Footer:"#",
        disableFilters:true,
        disableGlobalFilters:true,
        width: 60
    },
    {
        Header: "Name",
        accessor: "name",
        Cell: ({ row }) => row.original.name || '-'
    },
    {
      Header: "Organization Id",
      accessor: "organization_id"
    },
    {
        Header: "Program",
        Cell: ({ row, value }) => {
            var program='Coming from file';
            if(row.original.setups.CSVProgramRequest?.program_id){
                program='Program::'+row.original.setups.CSVProgramRequest?.program_id;
            }
            return program;
        }
    },
    {
        Header: "Import Type",
        accessor: "csv_import_types_name"
    },
    {
        Header: "Auto Import",
        Cell: ({ row, value }) => {
            var cronjob='Inactive';
            var color = "gray";
            if(row.original.setups.CsvImportSourceRequest?.status == 1){
                cronjob='Active';
                color = "green";
            }
            return <span style={{color:color}}>{cronjob}</span>;
        }
    },
    {
        Header: "Import Source",
        Cell: ({ row, value }) =>  {
            var source = 'Manual';
            if(row.original.setups.CsvImportSourceRequest?.id){
                source = row.original.setups.CsvImportSourceRequest?.id;
            }
            return source;
        }
    },
]
